import React, {Component} from "react"
import xosphereLogo from '../../assets/images/xosphere-logo.png';

class header extends Component {
    state = {
        wizard1: 'btn btn-primary btn-circle',
        wizard2: 'btn btn-primary btn-circle',
        wizard3: 'btn btn-primary btn-circle',
        wizard4: 'btn btn-primary btn-circle',
        wizard5: 'btn btn-primary btn-circle',
        wizard6: 'btn btn-primary btn-circle',
        wizard7: 'btn btn-primary btn-circle',
        wizard8: 'btn btn-primary btn-circle',
        currentWizard: this.props.currentWizard,
        show2: false,
        show3: false,
        show4: false,
        show5: false,
        show6: false,
        show7: false,
        show8: false,
        done: this.props.done || false,
        fromAws: this.props.fromAws || false
    };

    componentDidMount() {
        window.scrollTo(0, 0);
    }
    componentWillMount() {
        if (this.state.currentWizard === '1' && this.state.done) {
            this.setState({wizard1: 'btn btn-success btn-circle'})
        } else if (this.state.currentWizard === '2') {
            this.setState({wizard1: 'btn btn-success btn-circle', show2: true})
            if (this.state.done) {
                this.setState({wizard2: 'btn btn-success btn-circle'})
            }
        } else if (this.state.currentWizard === '3') {
            this.setState({
                wizard1: 'btn btn-success btn-circle',
                wizard2: 'btn btn-success btn-circle',
                show2: true,
                show3: true,
            })
        } else if (this.state.currentWizard === '4') {
            this.setState({
                wizard1: 'btn btn-success btn-circle',
                wizard2: 'btn btn-success btn-circle',
                wizard3: 'btn btn-success btn-circle',
                show2: true,
                show3: true,
                show4: true,
            })
        } else if (this.state.currentWizard === '5') {
            this.setState({
                wizard1: 'btn btn-success btn-circle',
                wizard2: 'btn btn-success btn-circle',
                wizard3: 'btn btn-success btn-circle',
                wizard4: 'btn btn-success btn-circle',
                show2: true,
                show3: true,
                show4: true,
                show5: true,
            })
        } else if (this.state.currentWizard === '6') {
            this.setState({
                wizard1: 'btn btn-success btn-circle',
                wizard2: 'btn btn-success btn-circle',
                wizard3: 'btn btn-success btn-circle',
                wizard4: 'btn btn-success btn-circle',
                wizard5: 'btn btn-success btn-circle',
                show2: true,
                show3: true,
                show4: true,
                show5: true,
                show6: true,
            })
        } else if (this.state.currentWizard === '7') {
            this.setState({
                wizard1: 'btn btn-success btn-circle',
                wizard2: 'btn btn-success btn-circle',
                wizard3: 'btn btn-success btn-circle',
                wizard4: 'btn btn-success btn-circle',
                wizard5: 'btn btn-success btn-circle',
                wizard6: 'btn btn-success btn-circle',
                show2: true,
                show3: true,
                show4: true,
                show5: true,
                show6: true,
                show7: true,
            })
        } else if (this.state.currentWizard === '8') {
            this.setState({
                wizard1: 'btn btn-success btn-circle',
                wizard2: 'btn btn-success btn-circle',
                wizard3: 'btn btn-success btn-circle',
                wizard4: 'btn btn-success btn-circle',
                wizard5: 'btn btn-success btn-circle',
                wizard6: 'btn btn-success btn-circle',
                wizard7: 'btn btn-success btn-circle',
                show2: true,
                show3: true,
                show4: true,
                show5: true,
                show6: true,
                show7: true,
                show8: true,
            })
        }
    }

    render() {
        let wizard2 = null;
        if (this.state.show2) {
            wizard2 = (
                <div className="stepwizard-step">
                    <button type="button" className={this.state.wizard2}
                            disabled="disabled">2
                    </button>
                    <p>Email Verification</p>
                </div>)
        }
        let wizard3 = null;
        if (this.state.show3) {
            wizard3 = (
                <div className="stepwizard-step">
                    <button type="button" className={this.state.wizard3}
                            disabled="disabled">3
                    </button>
                    <p>Enter Password</p>
                </div>)
        }
        let wizard4 = null;
        if (this.state.show4) {
            wizard4 = (
                <div className="stepwizard-step">
                    <button type="button" className={this.state.wizard4}
                            disabled="disabled">4
                    </button>
                    <p>Customer Information</p>
                </div>)
        }
        let wizard5 = null;
        if (this.state.show5 && !this.state.fromAws) {
            wizard5 = (
                <div className="stepwizard-step">
                    <button type="button" className={this.state.wizard5}
                            disabled="disabled">5
                    </button>
                    <p>Credit Card</p>
                </div>)
        }
        let wizard6 = null;
        if (this.state.show6) {
            if (this.state.fromAws) {
                wizard6 = (
                    <div className="stepwizard-step">
                        <button type="button" className={this.state.wizard6}
                                disabled="disabled">5
                        </button>
                        <p>AWS Account</p>
                    </div>)
            } else {
                wizard6 = (
                    <div className="stepwizard-step">
                        <button type="button" className={this.state.wizard6}
                                disabled="disabled">6
                        </button>
                        <p>AWS Configuration</p>
                    </div>)
            }
        }
        let wizard7 = null;
        if (this.state.show7) {
            if (this.state.fromAws) {
                wizard7 = (
                    <div className="stepwizard-step">
                        <button type="button" className={this.state.wizard7}
                                disabled="disabled">6
                        </button>
                        <p>Installation Region</p>
                    </div>)
            } else {
                wizard7 = (
                    <div className="stepwizard-step">
                        <button type="button" className={this.state.wizard7}
                                disabled="disabled">7
                        </button>
                        <p>Installation Region</p>
                    </div>
                )
            }
        }
        let wizard8 = null;
        if (this.state.show8) {
            if (this.state.fromAws) {
                wizard8 = (
                    <div className="stepwizard-step">
                        <button type="button" className={this.state.wizard8}
                                disabled="disabled">7
                        </button>
                        <p>Cloud Formation</p>
                    </div>)
            } else {
                wizard8 = (
                    <div className="stepwizard-step">
                        <button type="button" className={this.state.wizard8}
                                disabled="disabled">8
                        </button>
                        <p>Cloud Formation</p>
                    </div>)
            }
        }
        return (
            <div>
                <nav className="navbar navbar-light navbar-expand-lg">
                    <div className="container">
                        <a className="navbar-brand" href="https://xosphere.io/">
                            <img src={xosphereLogo} alt="" title="xosphere.io"/>
                        </a>
                        <div className="steps-container">
                            <div className="stepwizard">
                                <div className="stepwizard-row">
                                    <div className="stepwizard-step">
                                        <button type="button" className={this.state.wizard1}
                                                disabled="disabled">1
                                        </button>
                                        <p>Enter Email Address</p>
                                    </div>
                                    {wizard2}
                                    {wizard3}
                                    {wizard4}
                                    {wizard5}
                                    {wizard6}
                                    {wizard7}
                                    {wizard8}
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        )
    }
}


export default header;